import _ from 'lodash-es';
import angular from 'angular';
import kformUtils from '../../utils/kform-utils';
import template from './button.html';

const buttonConfig = /* @ngInject */ (
	/** @type {any} */ KformComponentsProvider,
	/** @type {any} */ FORM_OPTIONS,
) => {
	KformComponentsProvider.register('button', {
		title: 'Button',
		template,
		children:   false,
		selectable: true,
		settings: {
			autofocus: false,
			disabled: false,
			input: true,
			label: 'Submit',
			tableView: false,
			key: 'submit',
			size: 'md',
			leftIcon: '',
			rightIcon: '',
			block: false,
			action: 'submit',
			disableOnInvalid: false,
			theme: 'primary',
		},
		controller: /* @ngInject */ (/** @type {any} */ $scope) => {
			if ($scope.options && $scope.options.building) {
				return;
			}
			let clicked = false;
			const settings = $scope.component;
			$scope.getButtonType = () => {
				switch (settings.action) {
				case 'submit':
				case 'saveState': {
					return 'submit';
				}
				case 'reset': {
					return 'reset';
				}
				default: {
					return 'button';
				}
				}
			};

			$scope.hasError = () => {
				if (clicked && (settings.action === 'submit') && $scope.kformForm.$invalid) {
					$scope.disableBtn = true;
					return true;
				}

				clicked = false;
				$scope.disableBtn = false;
				return false;
			};

			const onCustom = () => {
				try {
					let parent = $scope.$parent;
					while (!parent.form) {
						parent = parent.$parent;
					}
					const flattened = kformUtils.flattenComponents(parent.form.components, true);
					// eslint-disable-next-line no-new-func
					(new Function(
						'form',
						'flattened',
						'components',
						'_merge',
						'$scope',
						'data',
						'row',
						$scope.component.custom.toString())
					)(
						parent.form,
						flattened,
						flattened,
						_.merge,
						$scope,
						$scope.data,
						$scope.data,
					);
				}
				catch (error) {
					/* eslint-disable no-console */
					console.warn(`An error occurred evaluating custom logic for ${ $scope.component.key}`, error);
					/* eslint-enable no-console */
				}
			};

			const onClick = () => {
				clicked = true;

				$scope.data[$scope.component.key] = true;
				switch (settings.action) {
				case 'submit': {
					$scope.submission.state = 'submitted';
					return;
				}
				case 'saveState': {
					$scope.submission.state = $scope.component.state;
					return;
				}
				case 'event': {
					$scope.$emit($scope.component.event, $scope.data);
					break;
				}
				case 'custom': {
					onCustom();
					break;
				}
				case 'url': {
					$scope.$emit('submitUrl', { url: $scope.component.url, component: $scope.component });
					break;
				}
				case 'reset': {
					$scope.resetForm();
					break;
				}
				case 'delete': {
					$scope.deleteSubmission();
					break;
				}
				default:
				}
			};

			$scope.$on('buttonClick', (
				/** @type {Event} */ event,
				/** @type {any} */ component,
				/** @type {string} */ componentId,
			) => {
				// Ensure the componentId's match (even though they always should).
				if (componentId !== $scope.componentId) {
					return;
				}
				onClick();
			});
		},
		onEdit: /* @ngInject */ (/** @type {any} */ $scope) => {
			$scope.actions = FORM_OPTIONS.actions;
			$scope.sizes = FORM_OPTIONS.sizes;
			$scope.themes = FORM_OPTIONS.themes;
		},
		icon:          'fa fa-stop',
		views:         [
			{
				name:     'Display',
				template: 'kform/components/button/display.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
	});
};

export default angular.module('app').config(buttonConfig);
